'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cn } from '../../lib/utils.js';
import { Accordion, AccordionContent as AccordionContentPrimitive, AccordionItem, AccordionTrigger, } from './primitives/accordion';
/** Overrides the primitive's fixed `h-(--radix-accordion-content-height)` on the inner div which clips dynamic content. */
function AccordionContent(_a) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    return (<AccordionContentPrimitive className={cn('h-auto', className)} {...props}>
      {children}
    </AccordionContentPrimitive>);
}
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
